import { useQuery } from "@tanstack/react-query";
import { getAdminUser } from "services/users.service";

export const useAdminUser = (enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["admin-user"],
    queryFn: () => getAdminUser(),
    enabled: enabled,
    select: (data) => data?.data,
    ...options,
  });
};
